import { TbPlus } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { usePlanActions, usePlanShowCreatePassengerDialog } from "@/stores/use-plan-table";

import CreateCustomUserDialog from "./CreateCustomPassengerDialog";

function CreateUserComp() {
    const showCreateDialog = usePlanShowCreatePassengerDialog();
    const { updatShowCreatePassengerDialog } = usePlanActions();
    const onClose = () => {
        updatShowCreatePassengerDialog(false);
    };
    return (
        <CommonPopup icon={TbPlus} title={"Yolcu Oluştur"} open={showCreateDialog} size="sm" onClose={onClose}>
            <CreateCustomUserDialog />
        </CommonPopup>
    );
}

export default CreateUserComp;
